import React, { useState } from 'react';
import { FreemiumInsightDto } from '../../../../overmind/actions/api/freemium-account';
import styles from './insights-widget.module.css';
import { WidgetCard } from '../../../analytics/analytics-filters/widget-card';
import { colourString } from '@keplerco/core';
import { PaywallModal } from '../../components/paywall/paywall-modal';

interface InsightsWidgetProps {
  insights: FreemiumInsightDto[];
  maxInsights?: number;
  showUpgradePrompt?: boolean;
}

export function InsightsWidget({
  insights,
  maxInsights = 5,
  showUpgradePrompt = true
}: InsightsWidgetProps): JSX.Element {
  // Limit the number of insights to display
  const displayedInsights = insights?.slice(0, maxInsights) || [];
  const [isPaywallModalOpen, setIsPaywallModalOpen] = useState(false);

  return (
    <div className={styles.insightsContainer}>


      {displayedInsights.length > 0 ? (
        <>
          {displayedInsights.map((insight, index) => (
            <WidgetCard key={index} title={insight.heading} subtitle={insight.subtitle}>
              <p className={styles.insightText}>{insight.insight}</p>
            </WidgetCard>
          ))}
          {showUpgradePrompt && (
            <button className={styles.addButton} type="button" onClick={() => setIsPaywallModalOpen(true)}>
              <span className="h4" style={{ color: colourString('default') }}>
                Upgrade to unlock more insights
              </span>
            </button>
          )}
        </>
      ) : (
        <div className={styles.noInsights}>
          <p>No insights available yet.</p>
        </div>
      )}
      <PaywallModal
        isOpen={isPaywallModalOpen}
        onClose={() => setIsPaywallModalOpen(false)}
      />
    </div>
  );
}
